import PostHogBillableUsageTemplate from "../../../../contents/docs/_snippets/posthog-billable-usage-template.mdx";
import FlagChargeEstimate from "../../../../contents/docs/feature-flags/snippets/flag-charge-estimate.mdx";
import * as React from 'react';
export default {
  PostHogBillableUsageTemplate,
  FlagChargeEstimate,
  React
};